<template>
  <th class="th-sortable" @click="onClick">
    <slot />

    <font-awesome-icon :icon="iconName" class="sort-icon" />
  </th>
</template>

<script>
export default {
  name: 'ThSortable',
  props: {
    fieldName: {
      type: String,
      required: true
    },
    direction: {
      type: String,
      default: 'none',
      validator: val => ['asc', 'desc', 'none'].includes(val)
    }
  },
  computed: {
    iconName() {
      switch (this.direction) {
        case 'asc': {
          return 'sort-up';
        }
        case 'desc': {
          return 'sort-down';
        }
        default:
          return 'sort';
      }
    }
  },
  methods: {
    onClick() {
      this.$emit('change', {
        sortBy: this.fieldName,
        sortDirection: this.direction === 'desc' ? 'asc' : 'desc'
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.th-sortable {
  cursor: pointer;

  > .sort-icon {
    margin: 0px 3px;
  }
}
</style>
